/**
 * Showing updated Insider messaging for churned retailers * https:www.figma.com/design/ToqJcQc1lVBDd5COGW6OcW/Insider-NUX-%26-Auto-enroll?node-id=8734-33078&t=qDeDYOz9qwQcWPb3-0
 */
export const INSIDER_CHURNED_MESSAGING_240709 = 'INSIDER_CHURNED_MESSAGING_240709';
